export default class {
    buttonsMinus = document.querySelectorAll('.stepper__btn--minus');
    buttonsPlus = document.querySelectorAll('.stepper__btn--plus');

    constructor() {
        this.buttonsMinus.forEach(btnMinus => {
            btnMinus.addEventListener('click', () => {
                const inputWrap = btnMinus.nextElementSibling;
                const input = inputWrap.querySelector('input');
                const value = parseInt(input.value);
                if (value > 12) {
                    input.value = value - 1;
                } else if (value === 12) {
                    btnMinus.classList.add('disabled');
                }
            })
        })

        this.buttonsPlus.forEach(btnPlus => {
            btnPlus.addEventListener('click', () => {
                const inputWrap = btnPlus.previousElementSibling;
                const input = inputWrap.querySelector('input');
                const btnMinus = inputWrap.previousElementSibling;
                const value = parseInt(input.value);                
                input.value = value + 1;
                if (value >= 12 && btnMinus.classList.contains('disabled')) {
                    btnMinus.classList.remove('disabled')
                }
            })
        })
    }
}
